import { Injectable } from "@angular/core";

/** This is service is a thin wrapper around localstorage
 * for testing and future refactoring ease
 */
@Injectable()
export class LocalStorageManagerService {
  constructor() {}
  public getItem(key: string): string {
    return localStorage.getItem(key);
  }

  public setItem(keyName: string, keyValue: string): void {
    localStorage.setItem(keyName, keyValue);
  }
  public removeItem(key: string): void {
    localStorage.removeItem(key);
  }
  public clear(): void {
    throw new Error("Can't clear local storage");
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/localStoageManager.service.ts